/* action type */
import type { Action } from '../../store/state/state-manager';

export const OPEN_ASSIGNMENT = 'OPEN_ASSIGNMENT';

/* action creator */
export const openAssignmentAction = (actionPayload: Action['payload']) => {
  return {
    type: OPEN_ASSIGNMENT,
    payload: actionPayload
  };
};
